/* @flow weak */
import * as actions from './actions'
import { Record } from 'immutable'

const State = Record(
  {
    error: null,
    online: false,
    started: false,
  },
  'app'
)

const appReducer = (state = new State(), action) => {
  switch (action.type) {
    case actions.BOOTSTRAP_SUCCESS:
      return state.set('started', true)

    case actions.BOOTSTRAP_ERROR:
      return state.set('error', action.payload)

    case actions.APP_OFFLINE:
      return state.set('online', false)

    case actions.APP_ONLINE:
      return state.set('online', true)

    default:
      return state
  }
}

export default appReducer
